import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: {
        if: [
          [
            {
              '!=': [
                {
                  '@': 'editingTerm',
                },
                null,
              ],
            },
            'Edit Term',
          ],
          'Create New Term',
        ],
      },
      type: 'details',
      content: {
        '{}': {
          fields: {
            '[]': [
              {
                '{}': {
                  id: 'name',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!subaward_tcs#!tc:!name',
                        },
                      },
                    },
                  },
                  value: {
                    '@>': [
                      {
                        '@': 'editingTerm',
                      },
                      'name',
                    ],
                  },
                },
              },
              {
                '{}': {
                  id: 'descr',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!subaward_tcs#!tc:!descr',
                        },
                      },
                    },
                  },
                  value: {
                    '@>': [
                      {
                        '@': 'editingTerm',
                      },
                      'descr',
                    ],
                  },
                },
              },
              {
                '{}': {
                  id: 'risk_threshold',
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!subaward_tcs#!tc:!risk_threshold',
                        },
                      },
                    },
                  },
                  value: {
                    '@>': [
                      {
                        '@': 'editingTerm',
                      },
                      'riskThreshold',
                    ],
                  },
                },
              },
            ],
          },
          onSave: {
            '{}': {
              action: {
                '{}': {
                  alias: 'sr.save-term',
                },
              },
              variables: {
                '{}': {
                  termId: {
                    '@$': 'termId',
                  },
                  termName: '${field:name}',
                  termDescr: '${field:descr}',
                  termRiskThreshold: '${field:risk_threshold}',
                },
              },
            },
          },
        },
      },
    },
  },
  subqueries: {
    editingTerm: {
      filter: {
        '=': [
          {
            '@.': '!id',
          },
          {
            '@$': 'termId',
          },
        ],
      },
      quantity: 1,
      target: 'ent:!subaward_tcs:!tc',
      selection: {
        '{}': {
          name: {
            '@.': '!name',
          },
          descr: {
            '@.': '!descr',
          },
          riskThreshold: {
            '@.': '!risk_threshold',
          },
        },
      },
    },
  },
}
